function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4999 14.35V8.05L74.1999 7.35C73.8499 7.35 71.7499 7 68.2499 7C53.8999 7 43.3999 11.2 37.4499 18.55C32.8999 15.75 26.5999 14 19.2499 14C15.7499 14 13.2999 14.35 13.2999 14.35L6.6499 15.4L6.9999 21.35C7.3499 31.85 12.5999 51.8 30.7999 51.8H31.4999V63.7C18.1999 65.45 6.9999 70 6.9999 70V77H76.9999V70C76.9999 70 65.7999 65.45 52.4999 63.7V52.5C74.5499 52.15 80.4999 27.3 80.4999 14.35ZM41.9999 63H38.4999V43.4C38.4999 43.4 37.7999 31.5 27.9999 31.5C27.9999 31.5 33.2499 34.3 34.6499 44.45C33.2499 44.8 31.8499 44.8 30.7999 44.8C14.6999 44.8 13.9999 21.35 13.9999 21.35C13.9999 21.35 16.0999 21 19.2499 21C25.8999 21 36.7499 22.4 39.8999 31.85C41.6499 16.1 59.4999 14 68.2499 14C71.3999 14 73.4999 14.35 73.4999 14.35C73.4999 14.35 73.4999 45.85 51.4499 45.85H48.9999C48.9999 38.85 55.9999 28.35 55.9999 28.35C45.4999 31.85 45.4999 45.5 45.4999 45.5V63H41.9999Z",
  fill: "#00cc66"
});

function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.bf64af8d.svg";
export { ForwardRef as ReactComponent };